import * as types from './mutation-types'
import _ from 'lodash'

export default {
  [types.SET_INSTITUTIONS] (state, institutions) {
    state.institutions = [...state.institutions, ...institutions]
  },
  [types.SET_INSTITUTIONS_META] (state, meta) {
    state.institutionsMeta = meta
  },
  [types.SET_GROUPS] (state, groups) {
    state.groups = [...state.groups, ...groups]
    state.groups = _.uniqBy(state.groups, 'employee_code')
  },
  [types.SET_GROUP_SELECTED] (state, employeeCode) {
    if (_.findIndex(state.groupEmployeeSelected, n => n === employeeCode) > -1) {
      _.remove(state.groupEmployeeSelected, n => n === employeeCode)
    } else {
      state.groupEmployeeSelected.push(employeeCode)
    }
    state.groupEmployeeSelected = [...state.groupEmployeeSelected]
  },
  [types.CLEAR_UNREAD_MESSAGES] (state, payload) {
    let groupIndex = -1
    let institutionIndex = -1
    _.forEach(state.groups, (n, index) => {
      groupIndex = index
      institutionIndex = _.findIndex(state.groups[index].institutions, n => n.institution_code === payload.institutionCode)
      if (institutionIndex > -1) return false
    })
    if (institutionIndex > -1) {
      state.groups[groupIndex].institutions[institutionIndex].total_unread_messages -= payload.total
    }
  },
  [types.SET_CURRENT_POST] (state, pos) {
    state.currentPos = pos
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/institution/mutations.js